<i18n>
{
	"en": {
		"stretch": "Stretch",
		"actual": "Actual",
		"ata": "ATA",
		"atd": "ATD",
		"eta": "ETA",
		"etd": "ETD",
		"save": "Save",
		"consignor": "Consignor",
		"despatchParty": "Despatch party",
		"consignee": "Consignee",
		"deliveryParty": "Delivery party",
		"invalidEtd": "Invalid ETD",
		"invalidEta": "Invalid ETA",
		"invalidAtd": "Invalid ATD",
		"invalidAta": "Invalid ATA",
		"transportInformation": "Transport Information",
		"stretches": "Stretches",
		"details": "Details",
		"sameAsCustomer": "Same as customer",
		"sameAsConsignor": "Same as consignor",
		"sameAsConsignee": "Same as consignee",
		"freightLines": "Freight lines",
		"priceLines": "Price lines",
		"loadingInformation": "Loading information",
		"freeText": "Free text",
		"events": "Events",
		"viaAddress": "Via address",
		"removeStretch": "Remove stretch",
		"noStartFound": "No suborder mathced the orders from location",
		"routeLost": "Could not make a valid route from suborders",
		"arrival": "Arrival",
		"departure": "Departure",
		"setArrivalTime": "Set arrival time",
		"setDepartureTime": "Set departure time",
		"orderSaved": "The order was saved",
		"cancelLabel": "Cancel",
		"tripNumber": "Trip number",
		"subOrderHasNoTrip": "Stretch not connected to trip",
		"vendor": "Owner",
		"subOrderHasNoTransporter": "No transporter registered",
		"tripHasNoVendor": "No owner registered",
		"registrationNumber": "Registration number",
		"subOrderHasNoRegistrationNumber": "Can't find registration number",
		"driver": "Driver",
		"subOrderHasNoDriver": "No driver registered",
		"ediLog": "EDI Log",
		"totalPrice": "Total price",
		"notSet": "Not set",
		"poReference": "PO reference",
		"sendersReference": "Senders reference",
		"otherReferences": "Other references",
		"systemReferences": "System references",
		"invoiceCurrency": "Invoice currency:",
		"invoiceNumber": "Invoice number:",
		"baseCurrency": "Base currency:",
		"externalTransporter": "External Transporter",
		"operationalStatus": "Operational status",
		"shouldNotBePlanned": "Should not be planned",
		"billingType": "Billing status:",
		"billingTypeAborted": "Cancelled",
		"billingTypeNotCleared": "Not cleared",
		"billingTypeSettlement": "Ready for settlement",
		"billingTypeInvoice": "Ready for invoice",
		"billingTypeUnkown": "Unknown",
		"serviceCode" : "Service code"
	},
	"no": {
		"stretch": "Strekning",
		"actual": "Faktisk",
		"ata": "ATA",
		"atd": "ATD",
		"eta": "ETA",
		"etd": "ETD",
		"save": "Lagre",
		"consignor": "Avsender",
		"despatchParty": "Henteadresse",
		"consignee": "Mottaker",
		"deliveryParty": "Leveringsadresse",
		"invalidEtd": "Ugyldig ETD",
		"invalidEta": "Ugyldig ETA",
		"invalidAtd": "Ugyldig ATD",
		"invalidAta": "Ugyldig ATA",
		"transportInformation": "Transportinformasjon",
		"stretches": "Strekninger",
		"details": "Detaljer",
		"sameAsCustomer": "Samme som kunde",
		"sameAsConsignor": "Samme som avsender",
		"sameAsConsignee": "Samme som mottaker",
		"freightLines": "Fraktlinjer",
		"priceLines": "Prislinjer",
		"loadingInformation": "Lasteinformasjon",
		"freeText": "Fritekst",
		"events": "Hendelser",
		"viaAddress": "Via adresse",
		"removeStretch": "Fjern strekning",
		"noStartFound": "Ingen underoppdrag matchet oppdragets fra adresse",
		"routeLost": "Kunne ikke lage en gyldig rute fra dette oppdragets underoppdrag",
		"arrival": "Ankomst",
		"departure": "Avgang",
		"setArrivalTime": "Sett ankomsttid",
		"setDepartureTime": "Sett avgangstid",
		"orderSaved": "Oppdraget ble lagret",
		"cancelLabel": "Avbryt",
		"tripNumber": "Tur nummer",
		"subOrderHasNoTrip": "Strekning er ikke knyttet til tur",
		"vendor": "Eier",
		"subOrderHasNoTransporter": "Ingen transportør registrert",
		"tripHasNoVendor": "Ingen eier registrert",
		"registrationNumber": "Registreringsnummer",
		"subOrderHasNoRegistrationNumber": "Finner ikke registreringsnummer",
		"driver": "Sjåfør",
		"subOrderHasNoDriver": "Ingen sjåfør registrert",
		"ediLog": "EDI Logg",
		"totalPrice": "Total pris",
		"notSet": "Ikke satt",
		"poReference": "PO referanse",
		"sendersReference": "Senders referanse",
		"otherReferences": "Andre referanser",
		"systemReferences": "Systemreferanser",
		"invoiceCurrency": "Faktura-valuta:",
		"invoiceNumber": "Fakturanummer:",
		"baseCurrency": "Grunn-valuta:",
		"externalTransporter": "Ekstern leverandør",
		"operationalStatus": "Operativ status",
		"shouldNotBePlanned": "Skal ikke planlegges",
		"billingType": "Faktura status:",
		"billingTypeAborted": "Annullert",
		"billingTypeNotCleared": "Ikke klarert",
		"billingTypeSettlement": "Klar for avregning",
		"billingTypeInvoice": "Klar for fakturering",
		"billingTypeUnkown": "Ukjent",
		"serviceCode" : "Servicekode"
	}
}
</i18n>
<template>
	<div v-if="subOrder !== undefined" ref="subOrderContent" class="sub-order-content">
		<div class="general-status">

			<OrderTypesFormInput
				:selectedItem="order.orderType"
				:orderHasTrip="orderHasTrip"
				disabled

				@select="setValue({key: 'orderType', value: $event})"
			/>

			<OrderStatusesFormInput
				v-if="orderHasTrip"
				:selectedItem="selectedSubOrder.status"
				:disabled="orderIsLocked"
				enableFocusNextOnKeyboardSelect

				@change="setSubOrderValue({ key: 'status', value: $event })"
			/>
			<TLabeledValue
				v-else
				:label="$t('operationalStatus')"
				:value="$t('shouldNotBePlanned')"
				labelMarginBottom="11px"
			/>

			<GoodsTypesFormInput
				:selectedItem="order.goodsType"
				disabled
				@change="setValue({ key: 'goodsType', value: $event })"
			/>

			<EconomicalStatusesFormInput
				:selectedItem="order.economicalStatus"
				disabled
				@change="adjustEconomicalStatus({ key: 'economicalStatus', value: $event })"
			/>

			<div class="invoice">
				<TLabeledValue
					class="invoice-label"
					:label="$t('invoiceNumber')"
					:value="invoiceNumberString"
					horizontal
				/>

				<TLabeledValue
					class="invoice-label"
					:label="$t('invoiceCurrency')"
					:value="invoicePriceAndCurrencyString"
					horizontal
				/>

				<TLabeledValue
					class="invoice-label"
					:label="$t('baseCurrency')"
					:value="basePriceAndCurrencyString"
					horizontal
				/>

				<TLabeledValue
					:label="$t('billingType')"
					:value="billingTypeString"
					horizontal
				/>
			</div>

			<ClerkInput
				:value="order.clerk"
				disabled
				@change="setValue({key: 'clerk', value: $event})"
			/>

			<t-text-input
				disabled
				:label="$t('poReference')"
				:value="order.poReference"
			/>

			<t-text-input
				disabled
				:label="$t('sendersReference')"
				:value="order.sendersReference"
			/>
		</div>
		<div class="customer-addresses-and-time">
			<CustomerAndAddresses
				:order="subOrder"
				:incoterm="incoterm"
				isSubOrder
				@changeDespatchParty="setSubOrderDespatchParty"
				@changeDeliveryParty="setSubOrderDeliveryParty"
			/>

			<Time
				class="time"
				:order="subOrder"
				:orderErrors="errors.subOrders[subOrder.id]"

				:atdSignature="atdSignature"
				:ataSignature="ataSignature"

				isSubOrder
				:isFirstSubOrder="isFirstSubOrder(subOrder)"
				:isLastSubOrder="isLastSubOrder(subOrder)"

				@changeEtdDate="setSubOrderDate({ key: 'etd', dateValue: $event, hasTime: 'dont-change' })"
				@changeEtdTime="setSubOrderDate({ key: 'etd', timeValue: $event, hasTime: Boolean($event) })"

				@changeAtdDate="setSubOrderDate({ key: 'atd', dateValue: $event, hasTime: 'dont-change' })"
				@changeAtdTime="setSubOrderDate({ key: 'atd', timeValue: $event, hasTime: Boolean($event) })"

				@changeEtaDate="setSubOrderDate({ key: 'eta', dateValue: $event, hasTime: 'dont-change' })"
				@changeEtaTime="setSubOrderDate({ key: 'eta', timeValue: $event, hasTime: Boolean($event) })"

				@changeAtaDate="setSubOrderDate({ key: 'ata', dateValue: $event, hasTime: 'dont-change' })"
				@changeAtaTime="setSubOrderDate({ key: 'ata', timeValue: $event, hasTime: Boolean($event) })"
			/>
		</div>
		<div class="suborder-transport-information">

			<div class="trip-information">
				<template v-if="subOrder.external">

					<div class="external-transporter-and-sent-with-edi-indication">

						<TLabeledValue
							:label="$t('externalTransporter')"
							:value="externalTransporter"
						/>

						<t-timpex-icon
							v-if="isSentOrBeingSentWithEdi"
							class="sent-with-edi-indication"
							icon="edi"
							type="bp"
							color="blue"
						/>

					</div>

					<TLabeledValue :label="$t('serviceCode')" :value="subOrder.serviceCode" />
				</template>



				<template v-else>
					<TLabeledValue :label="$t('tripNumber')" :value="tripNumberText"/>
					<TLabeledValue :label="$t('vendor')" :value="tripVendorNameText" />
					<TLabeledValue :label="$t('registrationNumber')" :value="tripCargoCarrierText" />
					<TLabeledValue :label="$t('driver')" :value="tripDriverText" />
				</template>
			</div>

		</div>

		<DetailsMain
			ref="detailsMain"
			isSubOrder
			:currentTabId="currentDetailTabId"
			@setSelectedTab="$emit('setSelectedDetailsTab', $event)"
		/>

	</div>
</template>

<script>
import EconomicalStatusesFormInput from '@/modules/economicalStatuses/EconomicalStatusesFormInput';
import ClerkInput from '@/modules/clerks/ClerkInput';
import GoodsTypesFormInput from '@/modules/goodsTypes/GoodsTypesFormInput';

import OrderTypesFormInput from '@/modules/orderTypes/OrderTypesFormInput';
import OrderStatusesFormInput from '@/modules/orderStatuses/OrderStatusesFormInput';
import { mapMutations, mapState, mapGetters } from '@/modules/newOrder/store/newOrder.store';
import { statuses, formatCurrency } from '@/core';

import CustomerAndAddresses from '@/modules/newOrder/common/CustomerAndAddresses';
import Time from '@/modules/newOrder/common/Time';
import DetailsMain from '@/modules/newOrder/details/DetailsMain';
import TLabeledValue from '@/components/evergreen/timpex/layers/TLabeledValue';
import {
	mapActions as mapActionsIncoterms,
	mapState as mapStateIncoterms
} from '@/modules/incoterms/store/incoterms.store';
import TTextInput from '@/components/evergreen/inputs/TTextInput';
import TTimpexIcon from '@/components/evergreen/timpex/icons/TTimpexIcon';

export default {
	name: 'SubOrderContent',
	components: {
		TTimpexIcon,
		TTextInput,
		TLabeledValue,
		Time,
		CustomerAndAddresses,
		EconomicalStatusesFormInput,
		ClerkInput,
		GoodsTypesFormInput,
		OrderTypesFormInput,
		OrderStatusesFormInput,
		DetailsMain,
	},
	props: {
		isNewOrder: {
			type: Boolean,
			required: true
		},
		currentDetailTabId: {
			type: String,
			required: true
		},
		orderHasTrip: Boolean,
	},
	computed: {
		...mapState([
			'order',
			'selectedSubOrder',
			'selectedSubOrderTrip',
			'errors',
			'isLoadingTrip',
			'subOrders',
		]),
		...mapGetters([
			'getEventBySubOrderIdAndType',
			'isFirstSubOrder',
			'isLastSubOrder',
			'orderIsLocked'
		]),
		...mapStateIncoterms(['incoterms']),
		subOrderStatus() {
			return this.subOrder === undefined ? undefined : this.subOrder.status;
		},
		atdSignature() {
			let event = this.getEventBySubOrderIdAndType(this.subOrder.id, 'departure');
			return !this.isFirstSubOrder(this.subOrder) || event === undefined ?
				undefined :
				{ name: event.signatureName, url: event.signatureUrl };
		},
		ataSignature() {
			let deliveredEvent = this.getEventBySubOrderIdAndType(this.subOrder.id, 'arrival');
			return !this.isLastSubOrder(this.subOrder) || deliveredEvent === undefined ?
				undefined :
				{ name: deliveredEvent.signatureName, url: deliveredEvent.signatureUrl };
		},
		trip() {
			return this.selectedSubOrderTrip;
		},
		tripNumberText() {
			if (this.isLoadingTrip) return '...';
			return this.trip && this.trip.tripNumber ? this.trip.tripNumber : this.$t('subOrderHasNoTrip');
		},
		tripVendorNameText() {
			if (this.isLoadingTrip) return '...';
			return this.trip && this.trip.vendor ? this.trip.vendor.name : this.$t('tripHasNoVendor');
		},
		tripCargoCarrierText() {
			if (this.isLoadingTrip) return '...';
			return this.trip && this.trip.cargoCarrier ? this.trip.cargoCarrier.registrationNumber : this.$t('subOrderHasNoRegistrationNumber');
		},
		tripDriverText() {
			if (this.isLoadingTrip) return '...';
			return this.trip && this.trip.driver ? this.trip.driver.name : this.$t('subOrderHasNoDriver');
		},
		externalTransporter() {
			return this.subOrder && this.subOrder.vendor ? this.subOrder.vendor.name : this.$t('subOrderHasNoTransporter');
		},
		subOrder() {
			return this.selectedSubOrder;
		},
		invoiceNumberString() {
			if (this.isNewOrder)
				return '...';

			else if (this.order.invoiceNumber === undefined || this.order.invoiceNumber === null)
				return this.$t('notSet');

			else
				return this.order.invoiceNumber;
		},
		basePriceAndCurrencyString() {
			if (this.isNewOrder)
				return '...';

			else if (this.order.totalPrice === undefined || this.order.totalPrice === null)
				return this.$t('notSet');

			else
				return formatCurrency(this.order.totalPrice, this.order.currency);
		},
		invoicePriceAndCurrencyString() {
			if (this.isNewOrder)
				return '...';

			else if (this.order.invoiceCurrencyPrice === undefined || this.order.invoiceCurrencyPrice === null)
				return this.$t('notSet');

			else
				return formatCurrency(this.order.invoiceCurrencyPrice, this.order.invoiceCurrency);
		},
		billingTypeString() {
			if (this.isNewOrder)
				return '...';

			if (this.order.billingType === undefined)
				return this.$t('notSet');

			if (this.order.billingType === 'aborted')
				return this.$t('billingTypeAborted');

			else if (this.order.billingType === 'settlement')
				return this.$t('billingTypeSettlement');

			else if (this.order.billingType === 'invoice')
				return this.$t('billingTypeInvoice');

			else if (this.order.billingType === 'notCleared')
				return this.$t('billingTypeNotCleared');

			else
				return this.$t('billingTypeUnkown');

		},
		isSentOrBeingSentWithEdi() {
			return this.subOrder.edi && this.subOrder.edi.outboundSchedule
				&& (
					this.subOrder.edi.outboundSchedule.isScheduled
					|| this.subOrder.edi.outboundSchedule.isSent
				);
		},
		incoterm() { // Need this because order only saves incotermCode, not the full incoterm object
			if (
				this.incoterms
				&& this.incoterms.length
				&& this.order.incotermsCode
			)
				return this.incoterms.find( incoterm => incoterm.code === this.order.incotermsCode );

			else if (this.order.incotermsCode)
				return { incotermsCode: this.order.incotermsCode };

			else
				return null;
		},
	},

	async created() {
		await this.getIncoterms();
	},

	methods: {
		...mapMutations([
			'setValue',
			'setSubOrderValue',
			'setSubOrderCustomer',
			'setSubOrderParty',
			'setSubOrderDespatchParty',
			'setSubOrderDeliveryParty',
			'setSubOrderDate',
		]),
		...mapActionsIncoterms([ 'getIncoterms' ]),

		adjustEconomicalStatus(data) {
			this.setValue(data);

			if (data.value === statuses.economical.cancelled)
				this.setValue({ key: 'status', value: statuses.operational.cancelled });
		},
		getStatusColor(value) {
			return statuses.color(value);
		},
		getFirstInputElementByRef(ref) {
			return ref.$el.querySelector('input');
		},
		getFirstTabableElementByRef(ref) {
			return ref.$el.querySelector('input:not([tabindex="-1"]), textarea');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.sub-order-content {
	height: 100%;
	display:flex;
	flex-direction: column;
}

.invoice {

	grid-area: 1 / 5 / 3 / 6;

	.invoice-label {
		margin-bottom: 12px;
	}
}


.customer-addresses-and-time {
	display: flex;
}

.time {
	margin-left: 16px;
	margin-top: 12px;
}

.general-status {
	display: grid;
	grid-template-columns: repeat(5, minmax(200px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
	margin-bottom: 20px;
}

hr {
	grid-column: 1 / auto-fill;
	height: 1px;
	background: get-color($border, 'default');
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	border: 0;
}

.textInfo {

	.header {
		user-select: none;
		font-size: 11px;
		font-weight: 600;
		line-height: 1.45;
		letter-spacing: 0.3px;
		color: get-color($text, 'dark');
		text-transform: uppercase;
		margin-bottom: 3px;
		margin-left: 1px;
	}
	.content {
		display: grid;
		column-gap: 5px;
		row-gap: 5px;
		line-height: 40px;
	}
}

.trip-information {
	display: grid;
	grid-template-columns: repeat(4, minmax(220px, 1fr));
	column-gap: 20px;
	margin-top: 12px;
	margin-bottom: 16px;
}

.external-transporter-and-sent-with-edi-indication {
	display: flex;
	align-items: center;

	.sent-with-edi-indication {
		margin-left: 10px;
	}
}
</style>
